import React, { useState, useEffect } from "react";
import axios from "axios";
// import "./ProfilePage.css";
// import { API_LoginURL} from "../";
import { API_LoginURL } from "../../../../config";
// import { API_BannerURL } from "../../../config";
import { API_BannerURL } from "../../../../config";
import Navbar from "../../../Header/header";
import SideBar from "../TeacherSidebar/TeacherSidebar";

const AdminProfile = () => {
  const [user, setUser] = useState({
    userId: 0,
    UserName: "",
    fname:"",
    lname:"",
    email: "",
    phone: "",
    profilePic: "https://via.placeholder.com/150", // Default placeholder
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(API_LoginURL + "User/LoggedInProfileData", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: localStorage.getItem("token"),
                },
              });
        if (response.data && response.data.length > 0) {
          // Assuming the API returns an array and we take the first user
          const userData = response.data[0];
          setUser({
            userID: userData.userId || 0,
            UserName: userData.userName || "",
            fname: userData.firstName || "",
            lname: userData.lastName || "",
            email: userData.userEmailId || "",
            phone: userData.phoneNumber || "",
            profilePic:
              userData.profilePicture || "https://via.placeholder.com/150",
          });
        }
      } catch (err) {
        setError("Failed to fetch user data");
        console.error("Error fetching user data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    
    // Validate passwords match
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert("New passwords don't match!");
      return;
    }
  
    // Validate password strength (optional enhancement)
    if (passwordData.newPassword.length < 8) {
      alert("Password should be at least 8 characters long!");
      return;
    }
  
    try {
      const response = await axios.post(
        API_LoginURL + "User/Changepassword",
        {
          userId: user.userId,
          newpassword: passwordData.newPassword,
          confirmpassword: passwordData.confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("token")}`,
          },
        }
      );
  
      if (response.status === 200) {
        alert("Password changed successfully!");
        // Reset form and close modal
        setPasswordData({
          newPassword: "",
          confirmPassword: "",
        });
        setShowChangePassword(false);
      }
    } catch (err) {
      // Enhanced error handling
      let errorMessage = "Failed to change password";
      if (err.response) {
        // Server responded with a status other than 2xx
        errorMessage = err.response.data?.message || errorMessage;
      } else if (err.request) {
        // Request was made but no response received
        errorMessage = "No response from server";
      }
      alert(errorMessage);
      console.error("Error changing password:", err);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("ProfilePicture", file);

    try {
      const response = await axios.post(API_LoginURL + "User/ProfilePicture", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("token"),
        },
      });

      if (response.status === 200) {
        setUser((prev) => ({
          ...prev,
          profilePic: response.data.profilePicUrl || previewUrl,
        }));
        setFile(null);
        alert("Profile picture updated successfully!");
      }
    } catch (err) {
      alert("Failed to upload profile picture");
      console.error("Error uploading profile picture:", err);
    }
  };

  if (loading) {
    return <div className="loading">Loading user data...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <SideBar />
                    <div className="main-panel">
          <div className="content-wrapper">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="profile-container">
                    <h1>Profile</h1>

                    <div className="profile-content">
                      <div className="profile-picture-section">
                        <div className="profile-picture-container">
                          <img
                            src={API_BannerURL + user.profilePic}
                            alt="Profile"
                            className="profile-picture"
                          />
                          <div className="upload-controls">
                            <input
                              type="file"
                              id="profile-upload"
                              accept="image/*"
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                            />
                            <label
                              htmlFor="profile-upload"
                              className="upload-btn"
                            >
                              Choose Image
                            </label>
                            {file && (
                              <button
                                onClick={handleUpload}
                                className="save-btn"
                              >
                                Save Picture
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="profile-info-section">
                        <div className="profile-info">
                        <div className="info-row">
                            <span className="info-label">User Name:</span>
                            <span className="info-value">{user.UserName}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">First Name:</span>
                            <span className="info-value">{user.fname}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Last Name:</span>
                            <span className="info-value">{user.lname}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Email:</span>
                            <span className="info-value">{user.email}</span>
                          </div>
                          <div className="info-row">
                            <span className="info-label">Phone:</span>
                            <span className="info-value">{user.phone}</span>
                          </div>
                        </div>

                        <button
                          onClick={() =>
                            setShowChangePassword(!showChangePassword)
                          }
                          className="change-password-btn"
                        >
                          {showChangePassword ? "Cancel" : "Change Password"}
                        </button>

                        {showChangePassword && (
                          <form
                            onSubmit={handleSubmitPassword}
                            className="password-form"
                          >
                            <div className="form-group">
                              <label>New Password</label>
                              <input
                                type="password"
                                name="newPassword"
                                value={passwordData.newPassword}
                                onChange={handlePasswordChange}
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label>Confirm New Password</label>
                              <input
                                type="password"
                                name="confirmPassword"
                                value={passwordData.confirmPassword}
                                onChange={handlePasswordChange}
                                required
                              />
                            </div>
                            <button type="submit" className="submit-btn">
                              Update Password
                            </button>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
